import React, { useState, useEffect, useMemo } from 'react';
import { Alert, ScrollView, TouchableOpacity, View } from 'react-native'

import tw from '../../../../../styles/tailwind';
import Text from '../../../../../components/Text';
import Icon from '../../../../../components/IcomoonIcon';
import { useForm } from 'react-hook-form';
import Input from '../../../../../components/Forms/Input';
import IconButton from '../../../../../components/IconButton';
import useFormSubmit from '../../../../../hooks/useFormSubmit';
import BottomSheetModal from '../../../../../components/BottomSheetModal';
import api from '../../../../../utils/api';
import { PaymentMethodSelector } from '../Fees/AddPaymentModal';



import { useQuery } from '@tanstack/react-query';
import Select from '../../../../../components/Forms/Select';
import BottomSheet from '../../../../../components/BottomSheet';
import DateSelector from '../../../../../components/Forms/DateSelector';
import FilePicker from '../../../../../components/FilePicker';

export function ExpenseCategorySelector({ control, name, communityId }) {
  const { isLoading, error, data: paymentMethods } = useQuery({
    queryKey: ['community.expenses-categories', communityId],
    queryFn: () => api.get(`/communities/${communityId}/expenses/categories`).then(response => response.data),
  })


  const options = useMemo(() => {
    const defaultValue = { value: "", label: "Sin definir" }

    const options = paymentMethods?.map(method => {
      return { value: method.uuid, label: method.name }
    })

    return options ? [...options] : []
  }, [paymentMethods])

  return (
    <Select
      control={control}
      name={name}
      placeholder={{ value: "", label: "Sin definir" }}
      items={options}
      rules={{}}
      style={{input: tw`bg-gray-100`}}
    />
  )
}



export default function NewExpenseModal({ onRequestClose, visible, onExpenseCreated, communityId }) {
  const { control, handleSubmit, watch, setValue, reset } = useForm();
  // const datete = watch("apply_date")
  // console.log(datete, typeof datete);
  


  const { submitForm, isSubmitting } = useFormSubmit({
    onSuccess: onExpenseCreated,
    onError: (error) => { },
    successToastMessage: "Gasto registrado correctamente",
    method: "post",
    endpoint: `/communities/${communityId}/expenses`,
  })



  useEffect(() => {
    if (visible) {
      reset({
        apply_date: new Date(),
      })
    } else {
      reset({})
    }
  }, [visible])



  function _submitForm(data) {
    const _data = {
      ...data,
      apply_date: data.apply_date?.toISOString().slice(0, 10), // envia solo la fecha (YYYY-MM-DD)
    }

    submitForm(_data)
  }


  return (
    <BottomSheet
      visible={true}
      height={700}
      onRequestClose={onRequestClose}
    >
      <View style={tw`flex-1 pt-5 px-5`}>
        <View style={tw`mb-4`}>
          <Text style={tw`mb-4 text-lg font-600 text-secondary`}>Registrar Gasto</Text>

          <TouchableOpacity
            style={tw`absolute -top-0 right-5 items-center justify-center`}
            onPress={onRequestClose}
          >
            <Icon name='close' style={tw`text-red`} size={26} />
          </TouchableOpacity>
        </View>


        <View style={tw`flex-1`}>
          {/* 
            Descripnción
          */}
          <View style={tw``}>
            <Text style={tw`text-gray-500`}>Descripción</Text>

            <Input
              control={control}
              name='name'
              placeholder='ej: Arreglo de reja de entrada'
              rules={{ required: true }}

            />
          </View>

          {/* 
            Monto
          */}
          <View style={tw`row justify-between mb-4`}>
            <Text style={tw`text-gray-500`}>Monto</Text>

            <View style={tw`row`}>
              <Input
                control={control}
                name='amount'
                placeholder='' style={{ container: tw`mb-0`, input: `w-42 pl-16` }}
                rules={{ required: true }}
                keyboardType="numeric"
              />
              <Text style={tw`absolute left-10 text-gray-500 top-4 `}>$</Text>
            </View>
          </View>


          {/* 
            Forma de pago
          */}
          <View style={tw`mb-4`}>
            <Text style={tw`text-gray-500`}>Forma de Pago</Text>

            <PaymentMethodSelector control={control} name={"payment_method_id"} communityId={communityId} />
          </View>


          {/* 
            Rubro
          */}
          <View style={tw`mb-0`}>
            <Text style={tw`text-gray-500`}>Rubro</Text>

            <ExpenseCategorySelector control={control} name={"category_id"} communityId={communityId} />
          </View>

          
          {/* 
            //! Fecha contable
          */}
          <View style={tw``}>
            <Text style={tw`text-gray-500`}>Fecha contable</Text>

            <DateSelector control={control} name="apply_date" rules={{ }} />
          </View>

          {/* 
            Comprobante
          */}

          <FilePicker
            onFileSelected={file => {
              console.log("onfileselected", file)
              setValue('image_uid', file?.uuid)
            }}
            label="Seleccionar comprobante"
            postUrl={`/communities/${communityId}/images`}
          />
        </View>


        <IconButton
          title={isSubmitting ? "Guardando..." : "Guardar Gasto"}
          style={tw`self-center my-5`}
          disabled={isSubmitting}
          onPress={handleSubmit(_submitForm)}
        />
      </View>

    </BottomSheet>
  );
}
